import { CustomDataGrid } from '../../../../components/CustomDataGrid';
import DashboardCards from '../../../../components/DashboardCard/DashboardCards';
import useLicenseList from './useLicenseList';

export default function LicenseList() {
  const { columns, data } = useLicenseList();

  return (
    <DashboardCards title="Licenses">
      <CustomDataGrid
        columns={columns}
        rows={data}
        pageSize={5}
      />
    </DashboardCards>
  );
}
